<template>
    <div>
        <div class="create-company-container w-100 mt-6 pb-5">
            <div class="create-company-header d-flex align-items-center justify-content-between">
                <span class="fs-14 pl-4 text-white">External User Information</span>
                <span class="pointer" @click="expandTabs">
                    <i class="text-white" :class="{'icon-chevron-double-up':consultant_expand, 'icon-chevron-double-down':!consultant_expand}" style="font-size: 20px;"></i>
                </span>
            </div>
            <div v-if="consultant_expand" class="px-6">
                <div class="row">
                    <!-- <div class="col-lg-12 col-md-12 col-sm-12 mt-2">
                        <span class="fs-14 text-black">Note: Use Personal Email as Login Email</span>
                    </div> -->
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
                        <div class="w-100 position-relative">
                            <span class="input-label">Personal Email ID<span class="pl-1 text-danger">*</span></span>
                            <div class="d-flex align-items-center mt-2">
                                <input type="text" maxlength="100" class="input-field" v-validate="'required|email'" :disabled="$route.path.startsWith('/stakeholder/editstakeholder/cmpid')"
                                    v-model="stakeholder_info.personal_email_id" placeholder="Enter Personal Email ID"
                                    name="personal_email_id" @change="checkEmailPer"/>
                            </div>
                            <div class="text-right position-absolute" style="right: 0;">
                                <span
                                    class="input-field-length">{{ stakeholder_info.personal_email_id.length }}/100</span>
                            </div>
                            <span class="invalid-feedback-form text-danger" v-show="errors.has('personal_email_id')">
                                {{errors.first('personal_email_id')}}
                            </span>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
                        <div class="w-100 position-relative">
                            <div class="d-flex align-items-center">
                                <span class="input-label">Login Email ID<span class="pl-1 text-danger">*</span></span>
                                <el-tooltip class="item" effect="dark" content="Use Personal Email as Login Email" placement="top">
                                    <input class="ml-2 mb-1 pointer" v-if="!$route.path.startsWith('/stakeholder/editstakeholder/cmpid')" :disabled="stakeholder_info.personal_email_id == '' || errors.first('personal_email_id')" type="checkbox" id="branch" v-model="login_same_as_personal" name="login_same_as_personal">
                                </el-tooltip>
                                <span class="fs-12 text-black pl-1 fw-500 d-block mb-1"> Use Personal Email as Login Email</span>
                            </div>
                            <div class="d-flex align-items-center mt-1" v-if="login_same_as_personal">
                                <input type="text" disabled maxlength="100" class="input-field" v-validate="'required|email'"
                                    v-model="stakeholder_info.personal_email_id" placeholder="Enter Personal Email ID"
                                    name="personal_email_id" />
                            </div>
                            <div v-if="login_same_as_personal">
                                <span v-if="check_email_per.status_id == 0" class="invalid-feedback-form text-danger">
                                    Login id already Exist
                                </span>
                            </div>
                            <div class="d-flex align-items-center mt-1" v-else>
                                <div class="position-relative w-100">
                                    <div class="d-flex align-items-center">
                                        <input type="text" maxlength="20" :disabled="$route.path.startsWith('/stakeholder/editstakeholder/cmpid')" class="input-field" v-validate="{required: true,regex: /^[a-zA-Z0-9-_.]+$/}"
                                            v-model="stakeholder_info.login_email_id" placeholder="Enter Login Email ID"
                                            name="login_email_id" @change="checkEmail" />
                                    </div>
                                    <div class="text-right position-absolute" style="right: 0;">
                                        <span class="input-field-length">{{ stakeholder_info.login_email_id.length }}/20</span>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center mx-2">
                                    <span>@</span>
                                </div>
                                <div class="d-flex align-items-center">
                                    <input type="text" maxlength="100" :disabled="true" :readonly="true" class="input-field"
                                        v-model="stakeholder_info.company_domain" placeholder="Enter"
                                    />
                                </div>
                            </div>
                            <span v-if="check_email.status_id == 0" class="invalid-feedback-form text-danger">
                                Login id already Exist
                            </span>
                            <span v-else class="invalid-feedback-form text-danger" v-show="errors.has('login_email_id')">
                                {{errors.first('login_email_id')}}
                            </span>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
                        <div class="w-100 position-relative">
                            <span class="input-label">First Name<span class="pl-1 text-danger">*</span></span>
                            <div class="d-flex align-items-center mt-2">
                                <input type="text" maxlength="45" class="input-field" v-validate="'required'"
                                    v-model="stakeholder_info.consultant_first_name" placeholder="Enter First Name"
                                    name="first_name" />
                            </div>
                            <div class="text-right position-absolute" style="right: 0;">
                                <span
                                    class="input-field-length">{{ stakeholder_info.consultant_first_name.length }}/45
                                </span>
                            </div>
                            <span class="invalid-feedback-form text-danger" v-show="errors.has('first_name')">
                                {{errors.first('first_name')}}
                            </span>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-6">
                        <div class="w-100 position-relative">
                            <span class="input-label">Last Name<span class="pl-1 text-danger">*</span></span>
                            <div class="d-flex align-items-center mt-2">
                                <input type="text" maxlength="45" class="input-field" v-validate="'required'"
                                    v-model="stakeholder_info.consultant_last_name" placeholder="Enter Last Name"
                                    name="last_name" />
                            </div>
                            <div class="text-right position-absolute" style="right: 0;">
                                <span
                                    class="input-field-length">{{ stakeholder_info.consultant_last_name.length }}/45
                                </span>
                            </div>
                            <span class="invalid-feedback-form text-danger" v-show="errors.has('last_name')">
                                {{errors.first('last_name')}}
                            </span>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-6">
                        <div class="row">
                            <div class="col-lg-7 col-md-7 col-sm-6">
                                <span class="input-label">Start Date</span>
                                <div class="d-flex align-items-center mt-2">
                                    <date-picker class="profile-date-picker calendar-edit-per input-field pt-0 pb-0 pr-0" 
                                    v-model="stakeholder_info.start_date" value-type="format" 
                                    :not-before="new Date()"
                                    :clearable="false" 
                                    @change="checkstartTime()"
                                    :editable="false" style="padding-left: 0px !important;"
                                    lang="en" type="date" format="DD/MM/YYYY">
                                </date-picker>
                                    <!-- <i class="icon icon-tick-success icon-check-circle"></i> -->
                                </div>
                            </div>
                            <div class="col-lg-5 col-md-5 col-sm-6 pl-5">
                                <span class="input-label">Time</span>
                                <div class="d-flex align-items-center mt-2">
                                    <el-select @change="endTime()" :disabled="stakeholder_info.start_date == ''" v-model="stakeholder_info.start_time" class="input-field" style="border-color: #080808 !important;margin-top: 0px;padding-top: 8px !important;padding-bottom: 0px !important;padding-left: 0px !important;padding-right: 0px !important;" placeholder="Start Time">
                                        <el-option
                                            v-for="(item, index) in time_format"
                                            :key="index" 
                                            :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                    <!-- <date-picker :disabled="stakeholder_info.start_date == ''" v-model="stakeholder_info.start_time" style="padding-right: 3px !important;padding-left: 0px !important;" :minute-step="1" name="start_time" class="profile-date-picker calendar-edit-per input-field calendar-down-arrow-grey" format="hh:mm" type="time" placeholder="HH:MM" value-type="format" lang="en"  :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker> -->
                                    <!-- <date-picker v-model="stakeholder_info.start_time" style="padding-right: 3px !important;padding-left: 0px !important;" name="start_time" class="profile-date-picker calendar-edit-per input-field calendar-down-arrow-grey" format="hh:mm A" type="time" placeholder="HH:MM" value-type="format" lang="en"  :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-6">
                        <div class="row">
                            <div class="col-lg-7 col-md-7 col-sm-6">
                                <span class="input-label">End Date</span>
                                <div class="d-flex align-items-center mt-2">
                                    <!-- <date-picker class="profile-date-picker calendar-edit-per input-field pt-0 pb-0 pr-0" 
                                        v-model="stakeholder_info.end_date" value-type="format" lang="en"
                                        :not-before="stakeholder_info.start_date ? stakeholder_info.start_date : new Date()"
                                        :clearable="false"
                                        :editable="false" style="padding-left: 0px !important;"
                                        type="date" format="DD/MM/YYYY">
                                    </date-picker> -->
                                    <date-picker class="profile-date-picker calendar-edit-per input-field pt-0 pb-0 pr-0" 
                                        v-model="stakeholder_info.end_date" value-type="format" lang="en"
                                        :not-before="new Date()"
                                        @change="checkEndTime()"
                                        :disabled="stakeholder_info.start_time == ''"
                                        :editable="true" style="padding-left: 0px !important;"
                                        type="date" format="DD/MM/YYYY">
                                    </date-picker>
                                    <!-- <i class="icon icon-tick-warning icon-check-circle"></i> -->
                                </div>
                            </div>
                            <div class="col-lg-5 col-md-5 col-sm-6 pl-5">
                                <span class="input-label">Time</span>
                                <div class="d-flex align-items-center mt-2">
                                    <el-select :disabled="stakeholder_info.end_date == ''" v-if="stakeholder_info.start_date == stakeholder_info.end_date" v-model="stakeholder_info.end_time" class="input-field" style="border-color: #080808 !important;margin-top: 0px;padding-top: 8px !important;padding-bottom: 0px !important;padding-left: 0px !important;padding-right: 0px !important;" placeholder="End Time">
                                        <el-option
                                            v-for="(item, index) in time_formats" :disabled="stakeholder_info.start_time >= item"
                                            :key="index"
                                            :label="item" style="padding-bottom: 0px !important;"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                    <el-select v-else :disabled="stakeholder_info.end_date == ''" v-model="stakeholder_info.end_time" class="input-field" style="border-color: #080808 !important;margin-top: 0px;padding-top: 8px !important;padding-bottom: 0px !important;padding-left: 0px !important;padding-right: 0px !important;" placeholder="End Time">
                                        <el-option
                                            v-for="(item, index) in time_formats"
                                            :key="index"
                                            :label="item" style="padding-bottom: 0px !important;"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                    <!-- <date-picker :disabled="stakeholder_info.start_date == ''" v-model="stakeholder_info.end_time" style="padding-right: 3px !important;padding-left: 0px !important;" :minute-step="1" name="end_time" class="profile-date-picker calendar-edit-per input-field calendar-down-arrow-grey" format="hh:mm"   type="time" placeholder="HH:MM" value-type="format" lang="en"  :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker> -->
                                    <!-- <date-picker v-model="stakeholder_info.end_time" style="padding-right: 3px !important;padding-left: 0px !important;" name="end_time" class="profile-date-picker calendar-edit-per input-field calendar-down-arrow-grey" format="hh:mm A" type="time" placeholder="HH:MM" value-type="format" lang="en"  :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-6">
                        <div class="w-100 position-relative">
                            <span class="input-label">Role<span class="pl-1 text-danger">*</span></span>
                            <div class="d-flex align-items-center mt-2">
                                <multiselect class="diginew-multiselect multiselect-height-issue-fix text-capitalize" v-validate="'required'" name="role" :show-labels="false" :searchable="true" :options="role_options" v-model="stakeholder_info.role" placeholder="Select Role" :disabled="$route.path.startsWith('/stakeholder/editstakeholder/cmpid')">
                                    <template slot="noOptions">
                                        <div class="text-secondary text-center fw-600">
                                            List is Empty
                                        </div>
                                    </template>
                                    <template slot="noResult">
                                        <div class="text-secondary text-center fw-600">
                                            No Results Found
                                        </div>
                                    </template>
                                </multiselect>
                                <!-- <input type="text" :readonly="true" :disabled="true" maxlength="100" class="input-field" v-validate="'required'"
                                    v-model="stakeholder_info.role" placeholder="Enter Role" style="text-transform: capitalize;"
                                    name="First-Name" /> -->
                            </div>
                            <span class="invalid-feedback-form text-danger" v-show="errors.has('role')">
                                {{errors.first('role')}}
                            </span>
                        </div>
                    </div>
                    <!-- <div class="col-lg-4 col-md-6 col-sm-12 mt-6" v-if="show_shares_field">
                        <div class="w-100 position-relative">
                            <span class="input-label">Allocate No. of Shares<span class="pl-1 text-danger">*</span></span>
                            <div class="d-flex align-items-center mt-2">
                                <input type="text" maxlength="15" class="input-field" v-validate="'required|numeric'"
                                    v-model="stakeholder_info.number_of_shares" placeholder="Enter No. of Shares"
                                    @input="stakeholder_info.number_of_shares = stakeholder_info.number_of_shares.replace(/[^0-9]/g, '')"
                                    name="number_of_shares" />
                            </div>
                            <span class="invalid-feedback-form text-danger" v-show="errors.has('number_of_shares')">
                                {{errors.first('number_of_shares')}}
                            </span>
                        </div>
                    </div> -->
                    <div class="col-lg-8 col-md-6 col-sm-12 mt-6 d-flex flex-column align-items-end justify-content-end" v-if="show_shares_field">
                        <div class="d-flex align-items-center">
                            <button v-if="is_edit" class="btn btn-outline-primary-new mr-3" @click="showInvestmentHistory" style="border-radius: 5px;">Investment History</button>
                            <button class="btn btn-new-primary" @click="showAddInvestment" style="border-radius: 5px;">{{investments.length && !is_edit ? 'Edit Investment' : '+ Add Investment'}}</button>
                        </div>
                        <span class="fs-12 text-secondary mt-1" v-if="investments.length && !is_edit">
                            Investment Added ({{total_shares_purchased}} Shares)
                        </span>
                    </div>
                </div>
            </div>
            <div class="mt-10 mb-10">
                <div class="d-flex align-items-center justify-content-center">
                     <button class="btn btn-outline-secondary" :disabled="save_create_btn_hide" @click="cancel" style="width: 120px;border-radius: 5px;">Cancel</button>
                     <button class="btn btn-new-primary ml-5" :disabled="!consultant_expand || save_create_btn_hide" @click="nextPermissionProduct" style="width: 120px;border-radius: 5px;">Next
                        <hollow-dots-spinner v-if="save_create_btn_hide" style="position: absolute;width: 160px !important;margin: 0;top: 12px;left: -15px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                    </button>
                </div>
            </div>
        </div>
        <add-investment v-if="add_investment" modal_name="AddInvestment" :edit_data="is_edit ? null : investments[0]" :submitting="investment_submitting" @addInvestment="addInvestment" @hideAddInvestment="hideAddInvestment"></add-investment>
        <investment-history v-if="investment_history" modal_name="InvestmentHistoryEdit" :stakeholder_id="$route.params.id" :stakeholder_name="stakeholder_data ? stakeholder_data.full_name || (stakeholder_data.first_name + ' ' + stakeholder_data.last_name) : ''" @hideInvestmentHistory="investment_history = false"></investment-history>
        <sweet-modal ref="warning_modal" overlay-theme="dark" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" overlay-theme="dark" icon="success">{{success_msg}}</sweet-modal>
    </div>
</template>
<script>
    import moment from 'moment';
    import axios from "axios";
    import { HollowDotsSpinner } from "epic-spinners";
    import consultant from '../mixins/stakeholder';
    import { SweetModal } from 'sweet-modal-vue';
    const AddInvestment = () => import('./AddInvestmentModal');
    const InvestmentHistory = () => import('./InvestmentHistoryModal');
    export default {
        mixins: [consultant],
        props: ['stakeholder_data', 'comp_data'],
        components: {
            SweetModal, HollowDotsSpinner, AddInvestment, InvestmentHistory
        },
        data() {
            return {
                time_formats: [
                    '00:00',
                    '00:30',
                    '01:00',
                    '01:30',
                    '02:00',
                    '02:30',
                    '03:00',
                    '03:30',
                    '04:00',
                    '04:30',
                    '05:00',
                    '05:30',
                    '06:00',
                    '06:30',
                    '07:00',
                    '07:30',
                    '08:00',
                    '08:30',
                    '09:00',
                    '09:30',
                    '10:00',
                    '10:30',
                    '11:00',
                    '11:30',
                    '12:00',
                    '12:30',
                    '13:00',
                    '13:30',
                    '14:00',
                    '14:30',
                    '15:00',
                    '15:30',
                    '16:00',
                    '16:30',
                    '17:00',
                    '17:30',
                    '18:00',
                    '18:30',
                    '19:00',
                    '19:30',
                    '20:00',
                    '20:30',
                    '21:00',
                    '21:30',
                    '22:00',
                    '22:30',
                    '23:00',
                    '23:30',
                ],
                time_format: [
                    '00:00',
                    '00:30',
                    '01:00',
                    '01:30',
                    '02:00',
                    '02:30',
                    '03:00',
                    '03:30',
                    '04:00',
                    '04:30',
                    '05:00',
                    '05:30',
                    '06:00',
                    '06:30',
                    '07:00',
                    '07:30',
                    '08:00',
                    '08:30',
                    '09:00',
                    '09:30',
                    '10:00',
                    '10:30',
                    '11:00',
                    '11:30',
                    '12:00',
                    '12:30',
                    '13:00',
                    '13:30',
                    '14:00',
                    '14:30',
                    '15:00',
                    '15:30',
                    '16:00',
                    '16:30',
                    '17:00',
                    '17:30',
                    '18:00',
                    '18:30',
                    '19:00',
                    '19:30',
                    '20:00',
                    '20:30',
                    '21:00',
                    '21:30',
                    '22:00',
                    '22:30',
                    '23:00',
                    '23:30',
                ],
                warning_msg: '',
                success_msg: '',
                stakeholder_info: {
                    personal_email_id: '',
                    login_email_id: '',
                    consultant_first_name:'',
                    consultant_last_name:'',
                    role: '',
                    company_domain: '',
                    start_date: '',
                    end_date: '',
                    start_time: '',
                    end_time: '',
                    // number_of_shares: '0',
                },
                investments: [],
                add_investment: false,
                investment_submitting: false,
                investment_history: false,
                consultant_expand: true,
                save_create_btn_hide:false,
                check_email: [],
                check_email_per: [],
                stringified_response: "",
                role_options: ['consultant', 'advisor', 'investor', 'banker', 'supplier', 'board member', 'share holder'],
                login_same_as_personal: false
            }
        },
        methods: {
            checkEndTime(){
                var curr_date = moment(new Date().toUTCString()).format("DD/MM/YYYY")
                this.time_formats = [
                    '00:00',
                    '00:15',
                    '00:30',
                    '00:45',
                    '01:00',
                    '01:15',
                    '01:30',
                    '01:45',
                    '02:00',
                    '02:15',
                    '02:30',
                    '02:45',
                    '03:00',
                    '03:15',
                    '03:30',
                    '03:45',
                    '04:00',
                    '04:15',
                    '04:30',
                    '04:45',
                    '05:00',
                    '05:15',
                    '05:30',
                    '05:45',
                    '06:00',
                    '06:15',
                    '06:30',
                    '06:45',
                    '07:00',
                    '07:15',
                    '07:30',
                    '07:45',
                    '08:00',
                    '08:15',
                    '08:30',
                    '08:45',
                    '09:00',
                    '09:15',
                    '09:30',
                    '09:45',
                    '10:00',
                    '10:15',
                    '10:30',
                    '10:45',
                    '11:00',
                    '11:15',
                    '11:30',
                    '11:45',
                    '12:00',
                    '12:15',
                    '12:30',
                    '12:45',
                    '13:00',
                    '13:15',
                    '13:30',
                    '13:45',
                    '14:00',
                    '14:15',
                    '14:30',
                    '14:45',
                    '15:00',
                    '15:15',
                    '15:30',
                    '15:45',
                    '16:00',
                    '16:15',
                    '16:30',
                    '16:45',
                    '17:00',
                    '17:15',
                    '17:30',
                    '17:45',
                    '18:00',
                    '18:15',
                    '18:30',
                    '18:45',
                    '19:00',
                    '19:15',
                    '19:30',
                    '19:45',
                    '20:00',
                    '20:15',
                    '20:30',
                    '20:45',
                    '21:00',
                    '21:15',
                    '21:30',
                    '21:45',
                    '22:00',
                    '22:15',
                    '22:30',
                    '22:45',
                    '23:00',
                    '23:15',
                    '23:30',
                    '23:45',
                ]
                if(this.stakeholder_info.end_date == curr_date){
                    var temp_start_time = ""
                    var curr_time = moment(new Date().toUTCString()).format("HH:mm");
                    if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
                        temp_start_time = curr_time.slice(0,3) + '00'
                    } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
                        temp_start_time = curr_time.slice(0,3) + '15'
                    } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
                        temp_start_time = curr_time.slice(0,3) + '30'
                    } else if(parseInt(curr_time.substring(3)) >= 45){
                        temp_start_time = curr_time.slice(0,3) + '45'
                    }
                    let indx = this.time_formats.indexOf(temp_start_time)
                    this.time_formats.splice(0,indx+1)
                }
            },
            endTime(){
                if(this.stakeholder_info.start_time >= this.stakeholder_info.end_time)
                {
                    this.stakeholder_info.end_time = '';
                }
            },
            checkstartTime(){
                var curr_date = moment(new Date().toUTCString()).format("DD/MM/YYYY")
                this.stakeholder_info.start_time = "";
                this.stakeholder_info.end_date = "";
                this.stakeholder_info.end_time = "";
                this.time_format = [
                    '00:00',
                    '00:15',
                    '00:30',
                    '00:45',
                    '01:00',
                    '01:15',
                    '01:30',
                    '01:45',
                    '02:00',
                    '02:15',
                    '02:30',
                    '02:45',
                    '03:00',
                    '03:15',
                    '03:30',
                    '03:45',
                    '04:00',
                    '04:15',
                    '04:30',
                    '04:45',
                    '05:00',
                    '05:15',
                    '05:30',
                    '05:45',
                    '06:00',
                    '06:15',
                    '06:30',
                    '06:45',
                    '07:00',
                    '07:15',
                    '07:30',
                    '07:45',
                    '08:00',
                    '08:15',
                    '08:30',
                    '08:45',
                    '09:00',
                    '09:15',
                    '09:30',
                    '09:45',
                    '10:00',
                    '10:15',
                    '10:30',
                    '10:45',
                    '11:00',
                    '11:15',
                    '11:30',
                    '11:45',
                    '12:00',
                    '12:15',
                    '12:30',
                    '12:45',
                    '13:00',
                    '13:15',
                    '13:30',
                    '13:45',
                    '14:00',
                    '14:15',
                    '14:30',
                    '14:45',
                    '15:00',
                    '15:15',
                    '15:30',
                    '15:45',
                    '16:00',
                    '16:15',
                    '16:30',
                    '16:45',
                    '17:00',
                    '17:15',
                    '17:30',
                    '17:45',
                    '18:00',
                    '18:15',
                    '18:30',
                    '18:45',
                    '19:00',
                    '19:15',
                    '19:30',
                    '19:45',
                    '20:00',
                    '20:15',
                    '20:30',
                    '20:45',
                    '21:00',
                    '21:15',
                    '21:30',
                    '21:45',
                    '22:00',
                    '22:15',
                    '22:30',
                    '22:45',
                    '23:00',
                    '23:15',
                    '23:30',
                    '23:45',
                ]
                if(this.stakeholder_info.start_date == curr_date){
                    var temp_start_time = ""
                    var curr_time = moment(new Date().toUTCString()).format("HH:mm");
                    if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
                        temp_start_time = curr_time.slice(0,3) + '00'
                    } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
                        temp_start_time = curr_time.slice(0,3) + '15'
                    } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
                        temp_start_time = curr_time.slice(0,3) + '30'
                    } else if(parseInt(curr_time.substring(3)) >= 45){
                        temp_start_time = curr_time.slice(0,3) + '45'
                    }
                    let indx = this.time_format.indexOf(temp_start_time)
                    this.time_format.splice(0,indx+1)
                }
            },
            async checkEmailPer() {
                let params = {
                    "login_email": this.stakeholder_info.personal_email_id
                };
                // this.check_email_per = await this.checkEmailExit(params);           
            },
            async checkEmail() {
                let params = {
                    "login_email": this.stakeholder_info.login_email_id+'@'+this.stakeholder_info.company_domain.replace(/.+\/\/|www.|\+/g, '')
                };
                // this.check_email = await this.checkEmailExit(params);
            },
            expandTabs() {
                this.consultant_expand = !this.consultant_expand;
            },
            nextPermissionProduct() {
                this.save_create_btn_hide = true
                this.$validator.validateAll().then(result => {
                    if (result) {
                        if(this.create_data.role == 'board member'){
                            this.create_data.role = 'board_member'
                        }
                        if(this.create_data.role == 'share holder'){
                            this.create_data.role = 'share_holder'
                        }
                        localStorage.setItem("stakeholder_data", JSON.stringify(this.create_data));
                        this.$emit('switchWizard');
                    }
                })
                this.save_create_btn_hide = false
            },
            showAddInvestment() {
                this.add_investment = true;
                setTimeout(() => {
                    this.$modal.show('AddInvestment');
                }, 100);
            },
            showInvestmentHistory() {
                // Remount each time so the latest history is loaded.
                this.investment_history = false;
                this.$nextTick(() => {
                    this.investment_history = true;
                    setTimeout(() => {
                        this.$modal.show('InvestmentHistoryEdit');
                    }, 100);
                });
            },
            hideAddInvestment() {
                this.add_investment = false;
            },
            async addInvestment(investment) {
                if (this.is_edit) {
                    // Existing stakeholder: save straight away, the update API doesn't take investments.
                    this.investment_submitting = true;
                    try {
                        let payload = {
                            investment_date: investment.investment_date,
                            shares_purchased: investment.shares_purchased,
                            amount_invested: Number(investment.amount_invested),
                            reference_id: investment.reference_id,
                        };
                        if (investment.notes) {
                            payload.notes = investment.notes;
                        }
                        let response = await this.addStakeholderInvestment({ stake_holder_id: this.$route.params.id, investment: payload });
                        this.investment_submitting = false;
                        this.$modal.hide('AddInvestment');
                        this.add_investment = false;
                        this.success_msg = response.message;
                        this.$refs.success_modal.open();
                        setTimeout(() => {
                            this.$refs.success_modal.close();
                        }, 2000);
                    }
                    catch(err) {
                        this.investment_submitting = false;
                        this.warning_msg = err;
                        this.$refs.warning_modal.open();
                    }
                    return;
                }
                this.investments = [investment];
                this.$modal.hide('AddInvestment');
                this.add_investment = false;
            },
            cancel() {
                this.$router.push('/stakeholder/listview/cmpid/'+this.$route.params.company_id);
            },
            async getCompData(company_id) {
                try {
                    let response = await this.getCompanyById(company_id);
                    this.stakeholder_info.company_domain = response.response.domain;
                }
                catch (err) {
                    // console.log(err);
                }
            },
        },
        mounted() {
            // this.checkEmail();
            if(this.$route.path.startsWith('/stakeholder/editstakeholder/cmpid')) {
                this.stakeholder_info.personal_email_id = this.stakeholder_data.personal_email;
                this.stakeholder_info.login_email_id = this.stakeholder_data.login_email.split("@")[0];
                this.stakeholder_info.consultant_first_name = this.stakeholder_data.first_name;
                this.stakeholder_info.consultant_last_name = this.stakeholder_data.last_name;
                this.stakeholder_info.role = this.stakeholder_data.role.replace("_", " ");
                // this.stakeholder_info.number_of_shares =this.stakeholder_data.number_of_shares != null && this.stakeholder_data.number_of_shares !== '' ? String(this.stakeholder_data.number_of_shares) : "0";
                this.stakeholder_info.company_domain = this.stakeholder_data.login_email.split("@")[1];
                this.stakeholder_info.start_date =  this.stakeholder_data.start_date ? this.stakeholder_data.start_date.split("-")[2]+"/"+this.stakeholder_data.start_date.split("-")[1]+"/"+this.stakeholder_data.start_date.split("-")[0] : "";
                this.stakeholder_info.end_date = this.stakeholder_data.end_date ? this.stakeholder_data.end_date.split("-")[2]+"/"+this.stakeholder_data.end_date.split("-")[1]+"/"+this.stakeholder_data.end_date.split("-")[0] : "";
                this.stakeholder_info.start_time = this.stakeholder_data.start_time ? this.stakeholder_data.start_time.split(":")[0]+':'+this.stakeholder_data.start_time.split(":")[1] : "";
                this.stakeholder_info.end_time = this.stakeholder_data.end_time ? this.stakeholder_data.end_time.split(":")[0]+':'+this.stakeholder_data.end_time.split(":")[1] : "";
                this.stringified_response = JSON.stringify(this.create_data)
            } else {
                this.getCompData(this.$route.params.company_id);
            }
        },
        computed: {
            fields_not_changed(){
                return this.stringified_response == JSON.stringify(this.create_data)
            },
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
            is_edit() {
                return this.$route.path.startsWith('/stakeholder/editstakeholder/cmpid');
            },
            show_shares_field() {
                return ['investor', 'board member', 'share holder'].includes(this.stakeholder_info.role);
            },
            total_shares_purchased() {
                return this.investments.reduce((total, x) => total + x.shares_purchased, 0);
            },
            create_data() {
                return {
                    personal_email: this.stakeholder_info.personal_email_id,
                    login_email: this.login_same_as_personal == true ? this.stakeholder_info.personal_email_id : this.stakeholder_info.login_email_id+'@'+this.stakeholder_info.company_domain.replace(/.+\/\/|www.|\+/g, ''),
                    first_name: this.stakeholder_info.consultant_first_name,
                    last_name: this.stakeholder_info.consultant_last_name,
                    start_date: this.stakeholder_info.start_date ? this.stakeholder_info.start_date.split('/')[2]+'-'+this.stakeholder_info.start_date.split('/')[1]+'-'+this.stakeholder_info.start_date.split('/')[0] : '',
                    start_time: this.stakeholder_info.start_time,
                    end_date: this.stakeholder_info.end_date ? this.stakeholder_info.end_date.split('/')[2]+'-'+this.stakeholder_info.end_date.split('/')[1]+'-'+this.stakeholder_info.end_date.split('/')[0] : '',
                    end_time: this.stakeholder_info.end_time,
                    company_id: this.$route.params.company_id,
                    role: this.stakeholder_info.role,
                    // ...(this.show_shares_field ? { number_of_shares: Number(this.stakeholder_info.number_of_shares) } : {}),
                    ...(this.show_shares_field && this.investments.length && !this.$route.path.startsWith('/stakeholder/editstakeholder/cmpid') ? { investment: this.investments[0] } : {}),
                    products: [],
                }
            }
        },
        created() {
            const dict = {
                custom: {
                    first_name: {
                        required: () => "First Name is required",
                        regex: () => "Enter a Valid Name",
                    },
                    last_name: {
                        required: () => "Last Name is required",
                        regex: () => "Enter a Valid Name",
                    },
                    role: {
                        required: () => "Role is required",
                    },
                    // number_of_shares: {
                    //     required: () => "No. of Shares is required",
                    //     numeric: () => "Enter a Valid No. of Shares",
                    // },
                    personal_email_id: {
                        required: () => "Personal Email is required",
                        email: () => "Enter a Valid Email",
                    },
                    login_email_id:{
                        required: () => "Login E-mail id is required",
                        regex: () => "Please enter valid Email Address",
                    },
                }
            };
            this.$validator.localize("en", dict);       
        },
    }
</script>

<style scoped>
    .btn-outline-primary-new {
        color: #00448b;
        border: 1px solid #00448b !important;
        background-color: #fff;
    }
    .btn-outline-primary-new:hover {
        color: #fff;
        background-color: #00448b;
    }
    .btn-outline-secondary {
        color: #e82828;
        border: 1px solid #e82828 !important;
    }
    .btn-outline-secondary:hover {
        color: #fff;
        background-color: #e82828;
        border-color: #e82828 !important;
    }
    .icon-tick-warning{
        color: #ff9a06
    }
    .icon-tick-success{
        color: #008a63;
    }
    .create-company-container {
        background-color: #fff;
        padding: 0px 0 0px 0;
    }

    .create-company-container:first-child {
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
    }

    .create-company-container:nth-child(2) {
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
    }

    .create-company-container:last-child {
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
    }

    .overflow-auto {
        overflow: auto;
    }

    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }

    .input-field {
        border-radius: 8px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100%;
        height: 40px;
    }

    .input-field-length {
        opacity: 0.5;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 0.3px;
        color: #000;
    }

    .btn-new-cancel {
        color: #fff;
        background-color: #d51650;
        border-radius: 5px;
        padding-left: 35px;
        padding-right: 35px;
        text-transform: none;
        font-weight: 500;
        border: 2px solid #d51650;
        line-height: 30px;
        box-shadow: none;
    }
    .profile-date-picker {
        padding: 5px 10px !important;
    }
    .btn-new-primary:disabled{
        cursor: no-drop !important;
    }
    .btn:disabled{
        pointer-events: auto !important
    }
</style>